import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);
        
        this.items = this.el.querySelectorAll('.m-menus_list_item_link');
        this.medias = this.el.querySelectorAll('.m-menus_content_media_item');
    }

    init() {
        this.items.forEach((item) => {
            item.addEventListener('mouseenter', () => {
                let index = item.getAttribute('data-index');
                this.el.querySelector('.m-menus_content_media_item[data-index="' + index + '"]').classList.add('-visible');
            });
            item.addEventListener('mouseleave', () => {
                let index = item.getAttribute('data-index');
                this.el.querySelector('.m-menus_content_media_item[data-index="' + index + '"]').classList.remove('-visible');
            });
        });
    }
}
